import React from 'react';
import RecentMessages from './recent-messages';
import SearchMessages from './search-messages';
const $ = window.$;

class MessagesTabs extends React.Component {
  componentDidMount() {
    $(document).ready(() => {
      $('#alert-search-tabs').tabs();
    });
  }
  render() {
    return (
      <div className={this.props.className}>
      <h5>Notification History</h5>
        <div className="col m12 s12 center">
          <ul id={'alert-search-tabs'} className="tabs tabs-fixed-width ">
            <li className="tab col s3"><a href="#recent" className="tab-text">Recent</a></li>
            <li className="tab col s3"><a href="#search" className="tab-text">Search</a></li>
          </ul>
        </div>
        <div id="recent" className="col s12">
          <RecentMessages className="center"/>
        </div>
        <div id="search" className="col s12">
          <SearchMessages className="center"/>
        </div>

      </div>
    )
  }
}

export default MessagesTabs;



// WEBPACK FOOTER //
// ./src/components/alert/messagesTabs.js